import { CURRENCIES } from '../constants'

interface CurrencySelectProps {
  id: string
  value: string
  onChange: (value: string) => void
  // Show full names (e.g., "DKK - Danish Krone") instead of just codes
  showNames?: boolean
}

/**
 * Reusable currency dropdown component.
 */
export function CurrencySelect({ id, value, onChange, showNames = false }: CurrencySelectProps) {
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {CURRENCIES.map(({ code, name }) => (
        <option key={code} value={code}>
          {showNames ? `${code} - ${name}` : code}
        </option>
      ))}
    </select>
  )
}
